import type { AuthSession } from './types'

const SESSION_KEY = 'ncp-auth-session'

export function saveSession(session: AuthSession) {
  if (typeof window === 'undefined') {
    return
  }

  localStorage.setItem(SESSION_KEY, JSON.stringify(session))
}

export function clearSession() {
  if (typeof window === 'undefined') {
    return
  }

  localStorage.removeItem(SESSION_KEY)
}

export function getSession(): AuthSession | null {
  if (typeof window === 'undefined') {
    return null
  }

  const raw = localStorage.getItem(SESSION_KEY)
  if (!raw) {
    return null
  }

  try {
    const session = JSON.parse(raw) as AuthSession
    if (Date.now() > session.tokens.expiresAt) {
      clearSession()
      return null
    }

    return session
  } catch {
    clearSession()
    return null
  }
}
